
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.333 4a4 4 0 014-4h20a4 4 0 014 4v20a4 4 0 01-4 4h-20a4 4 0 01-4-4V4z","fill":"#DCFCE7"}}),_c('path',{attrs:{"d":"M7.349 20.304l-.14-.14a.747.747 0 010-1.058l3.13-3.129a.736.736 0 01.528-.219.751.751 0 01.53.22l2.35 2.348 5.232-5.232c-.152-.15-.305-.3-.454-.454l-.216-.22a.45.45 0 01-.137-.544.453.453 0 01.094-.14.558.558 0 01.4-.138c.866-.039 1.729-.082 2.594-.122h.05a.519.519 0 01.394.143.526.526 0 01.125.412l-.04.844c-.028.565-.056 1.125-.08 1.686a.619.619 0 01-.162.43.578.578 0 01-.128.094.439.439 0 01-.214.058.505.505 0 01-.356-.19l-.668-.663-5.903 5.902a.75.75 0 01-1.06 0l-2.35-2.349-2.461 2.461a.748.748 0 01-1.058 0zm4.022-6.497v-5.5h.847l.147.496h.05a1.205 1.205 0 011.083-.567 1.24 1.24 0 011.059.523c.278.43.412.94.382 1.452.008.362-.053.722-.179 1.062-.1.274-.277.513-.51.687-.229.16-.502.242-.78.236a1.268 1.268 0 01-1.055-.489h-.055c.037.32.055.504.055.554v1.549l-1.044-.003zm1.226-4.5a1.36 1.36 0 00-.185.784v.113c-.024.305.04.61.183.881a.653.653 0 00.579.267c.466 0 .7-.385.7-1.154a1.65 1.65 0 00-.173-.846.589.589 0 00-.542-.282.657.657 0 00-.562.237zM9.65 12.126L8.457 10.21h-.563v1.915h-1.06V7.132h1.455c.528-.04 1.055.09 1.504.371a1.323 1.323 0 01.49 1.124c.006.28-.078.556-.24.785-.175.24-.413.427-.688.54a194.895 194.895 0 001.468 2.174H9.65zM7.894 9.349h.34c.258.02.516-.039.741-.167a.6.6 0 00.24-.526.546.546 0 00-.245-.506A1.481 1.481 0 008.214 8h-.32v1.35z","fill":"#4CB244"}})])
          )
        }
      }
    